import React, { forwardRef, memo } from 'react'

const PercentIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="34.3"
      height="34.3"
      viewBox="0 0 34.3 34.3"
      fill="none"
      {...props}>
      <path
        d="M26.7569 9.49609L7.55693 28.6961"
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4819 14.2461C12.5106 14.2461 14.1569 12.5998 14.1569 10.5711C14.1569 8.54242 12.5106 6.89609 10.4819 6.89609C8.45327 6.89609 6.80693 8.54242 6.80693 10.5711C6.80693 12.5998 8.45327 14.2461 10.4819 14.2461Z"
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.1319 27.8961C26.1606 27.8961 27.8069 26.2498 27.8069 24.2211C27.8069 22.1924 26.1606 20.5461 24.1319 20.5461C22.1033 20.5461 20.4569 22.1924 20.4569 24.2211C20.4569 26.2498 22.1033 27.8961 24.1319 27.8961Z"
        stroke="white"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

PercentIcon.displayName = 'PercentIcon'

export default memo(PercentIcon)
